module.exports = __webpack_public_path__ + "static/media/textIcon.22613343.png";